import React, { useState } from 'react';
import { Button, Select, Space } from 'antd';
import { EditWrapper } from './styled';
import apptracker from '@src/utils/sensor/apptracker';
import { CONFIGURED_FLOW_WIDGET } from '@src/utils/sensor/track';

function Edit({ flowConfigMeta, onSave, onCancel, currentFlowId }) {
  const [flowId, setFlowId] = useState(currentFlowId);

  const handleSave = () => {
    onSave({ flowId });
    apptracker(CONFIGURED_FLOW_WIDGET, { flowId });
  };

  const handleChange = (flow) => {
    setFlowId(flow);
  };

  const openActivation = () => {
    window.open(`/app/activation/workflow/flow/new`, '_blank');
  };

  return (
    <EditWrapper>
      <Space direction="vertical" className="wrapper">
        <Space>
          <Select
            placeholder="Select a Flow"
            style={{ width: 250 }}
            value={flowId}
            onChange={handleChange}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              String(option?.children ?? '')
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {Object.keys(flowConfigMeta)
              .map((flowId) => flowConfigMeta[flowId])
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((flow) => (
                <Select.Option key={flow.id} value={flow.id}>
                  {flow.name}
                </Select.Option>
              ))}
          </Select>
        </Space>
        <Space>
          <Button type="primary" size="small" onClick={handleSave} disabled={!flowId} ghost>
            Save
          </Button>
          <Button type="default" size="small" onClick={onCancel} disabled={flowId === null}>
            Cancel
          </Button>
        </Space>
      </Space>
      <Space className="create-flow">
        <Button type="link" onClick={openActivation}>
          + Create Flow
        </Button>
      </Space>
    </EditWrapper>
  );
}

export default Edit;
